







import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import {
  addKnowFavorite,
  addOrgFavorite, addProductFavorite, addRequireFavorite, delKnowFavorite,
  delOrgFavorite, delProductFavorite, delRequireFavorite,
} from 'service/api';

const routeToAddApi = {
  orgFavor: addOrgFavorite,
  productFavor: addProductFavorite,
  requireFavor: addRequireFavorite,
  knowledgeFavor: addKnowFavorite,
};

const routeToDelApi = {
  orgFavor: delOrgFavorite,
  productFavor: delProductFavorite,
  requireFavor: delRequireFavorite,
  knowledgeFavor: delKnowFavorite,
};

interface FavorRes {
  state: boolean;
  message: string;
}

type RouteName = 'orgFavor' | 'productFavor' | 'requireFavor' | 'knowledgeFavor';

@Component
export default class FavoriteCard extends Vue {
  @Prop(Boolean) favorite!: boolean;

  @Prop(String) id!: string;

  currentRoute: RouteName | undefined;

  doFavor() {
    if (this.favorite) {
      this.cancelFavor();
    } else {
      this.addFavor();
    }
  }

  @Emit('change')
  async addFavor() {
    if (this.currentRoute) {
      const res = await routeToAddApi[this.currentRoute](this.id);
      if ((res as FavorRes).state) {
        this.$message.success('收藏成功！');
      } else {
        this.$notify.error((res as FavorRes).message);
      }
    }
  }

  @Emit('change')
  async cancelFavor() {
    if (this.currentRoute) {
      const res = await routeToDelApi[this.currentRoute](this.id);
      if ((res as FavorRes).state) {
        this.$message.success('取消收藏成功！');
      } else {
        this.$notify.error((res as FavorRes).message);
      }
    }
  }

  mounted() {
    this.currentRoute = (this.$route.meta.favorName as RouteName);
  }
}
